export default __webpack_public_path__ + "105c9d351e5cabcc4504a9b863032ca3.png";